var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id === 'department')?_c('department-master'):(_vm.id === 'position')?_c('position-master'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }